import { ChangeLanguageButton } from '../change-language-button';

export function BrandedLayout({ children }) {
  return (
    <div className="w-full h-[100dvh] relative overflow-hidden bg-brand flex">
      <div className="relative pb-5 w-full sm:w-[640px] max-h-[100dvh] overflow-y-auto flex-shrink-0 flex flex-col">
        <header className="pt-2.5 px-5 mb-5 bg-white">
          <div className="flex flex-row justify-stretch items-center gap-5 pb-5 border-b border-solid">
            <img
              src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
              alt="logo"
              className="ml-4 grow h-24 brand-logo"
            />
            <div className="grow-0">
              <ChangeLanguageButton />
            </div>
          </div>
        </header>

        <main className="px-5 flex-grow flex flex-col">
          <section>{children}</section>
        </main>
      </div>
      <div className="relative flex-[1.25] hidden sm:block before:absolute before:inset-0 before:bg-white/80 brand-background"></div>
    </div>
  );
}
